module.exports = "/_next/static/images/b19d2ec7e26af2ef5554f47d2ef9f5b3-card-lock-icon.svg.webp";